import {mediasTyped} from '../../media';
import {parseSchedule} from './schedule';
import {parsePriceList} from './siteData';

const buildSections = ({site = {}, nearby = [], lang = 'fr'}) => {
  const sections = [{id: 'infos', i18nKey: 'v3.nav.infos'}];

  if (parsePriceList(site.price_list, lang).length > 0) {
    sections.push({id: 'tarifs', i18nKey: 'v3.nav.tarifs'});
  }
  const hasSchedule = parseSchedule(site.schedule).length > 0;
  const hasAccess = !!(site.access_transport && (site.access_transport[`text_${lang}`] || site.access_transport.text_fr));
  if (hasSchedule || hasAccess) {
    sections.push({id: 'pratique', i18nKey: 'v3.nav.pratique'});
  }
  const typed = mediasTyped(site.medias || []);
  if ((typed.image || []).length > 0) {
    sections.push({id: 'medias', i18nKey: 'v3.nav.medias'});
  }
  const hasComments = (site.feedbacks && site.feedbacks.comments || []).length > 0;
  if (hasComments || (site.ambassador_review && site.ambassador_review.content)) {
    sections.push({id: 'avis', i18nKey: 'v3.nav.avis'});
  }
  if (nearby.length > 0) {
    sections.push({id: 'proximite', i18nKey: 'v3.nav.proximite'});
  }
  return sections;
};

export default buildSections;
